import { css } from 'styled-components';

import { ContentColor } from '../../contentColor';
import { FontWeight } from '../../fontWeight';

const commonHeadingStyles = css`
	font-family: 'Open Sans';
	font-style: normal;
	font-weight: 800;
	letter-spacing: -0.5px;

	margin: 0;
`;

export interface HeadingProps {
	contentColor?: ContentColor;
	fontWeight?: FontWeight;
}

export default commonHeadingStyles;
